// extracted by mini-css-extract-plugin
module.exports = {"firstLine":"AzureUserPicker_firstLine__pWXMG","secondLine":"AzureUserPicker_secondLine__vzBNy","thirdLine":"AzureUserPicker_thirdLine__1qQIS"};